import { ServicePackageAddon, ServicePackageType } from '@/api/Cart/cart.interfaces';
import {
    ServicePackage,
    ServicePackageName,
} from '@ui/components/ServicePackage/ServicePackage.interfaces';
import {
    getPostBookingPricePerMarket,
    RECOMMENDED_SERVICE_PACKAGE,
} from './ServicePackage.config';
import { t } from '@shared/helpers/translation';
import { getMoneyObjectAsString } from '@shared/helpers/money';
import store from '@/store';

export function getServicePackageContent(addon: ServicePackageAddon): ServicePackage {
    const basePackage = {
        price: addon.Price,
        originalPrice: addon.OriginalPrice,
        link: addon.LinkUrl,
        isRecommended: false,
    };
    let servicePackage: ServicePackage | null;

    switch (addon.Ordinal) {
        case ServicePackageType.None:
            servicePackage = {
                ...basePackage,
                link: null,
                name: ServicePackageName.None,
                title: t({ key: 'service_package.no_service_package' }),
                usps: [
                    {
                        title: null,
                        text: t({
                            key: 'service_package.usp_service_fee',
                            values: [getPostBookingPricePerMarket()],
                        }),
                        icon: 'InfoCircle',
                    },
                ],
            };
            break;

        case ServicePackageType.Basic:
            servicePackage = {
                ...basePackage,
                name: ServicePackageName.Basic,
                isRecommended: true,
                title: t({ key: 'service_package.basic_service_package' }),
                usps: [
                    {
                        title: t({ key: 'service_package.usp_priority_title' }),
                        text: t({ key: 'service_package.usp_priority' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_hotel_voucher_title' }),
                        text: t({ key: 'service_package.usp_hotel_voucher' }),
                        badgePrice: getBadgePrice(addon),
                        showBadge: true,
                        badgeColor: 'green',
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_compensation_support_title' }),
                        text: t({ key: 'service_package.usp_compensation_support' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                ],
            };
            break;

        case ServicePackageType.Premium:
            servicePackage = {
                ...basePackage,
                name: ServicePackageName.Premium,
                title: t({ key: 'service_package.premium_service_package' }),
                usps: [
                    {
                        title: t({ key: 'service_package.usp_priority_title' }),
                        text: t({ key: 'service_package.usp_priority' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_hotel_voucher_title' }),
                        text: t({ key: 'service_package.usp_hotel_voucher' }),
                        showBadge: true,
                        badgeColor: 'green',
                        badgePrice: getBadgePrice(addon),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_compensation_support_title' }),
                        text: t({ key: 'service_package.usp_compensation_support' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                    {
                        title: t({ key: 'service_package.usp_sms_title' }),
                        text: t({ key: 'service_package.usp_sms' }),
                        icon: 'Check',
                        color: 'jungle',
                    },
                ],
            };
            break;
        default:
            return {
                ...basePackage,
                name: ServicePackageName.None,
                title: '',
                usps: [],
            };
    }

    return {
        ...servicePackage,
        isRecommended: servicePackage?.name === RECOMMENDED_SERVICE_PACKAGE,
    };
}

function getBadgePrice(addon: ServicePackageAddon): string {
    if (!addon.OriginalPrice) return '';
    return getMoneyObjectAsString(addon.OriginalPrice);
}

export function getBaselineLinkUrl(): string {
    const servicePackages = store.getters['cart/getServicePackageAddons'];
    const basicServicePackage = servicePackages.find(
        (pkg: ServicePackageAddon) => pkg.Ordinal === ServicePackageType.Basic
    );

    return basicServicePackage?.LinkUrl || 'https://www.sembo.se/';
}
